import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from 'src/helpers/apiCall'
import { GET } from 'src/consts/methods'
import {
  FETCH_EMAIL_TEMPLATE,
  FETCH_EMAIL_TEMPLATE_FAIL,
  FETCH_EMAIL_TEMPLATE_SUCCESS,
  FetchEmailTemplateActionType
} from 'src/redux/emailTemplateReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchEmailTemplateFlow(action: FetchEmailTemplateActionType): Generator<any, void, any> {
  try {
    const response = yield call(apiCall, {
      endpoint: `/admin/email_templates/${action.payload.id}`,
      method: GET,
      params: {}
    })
    yield put(FETCH_EMAIL_TEMPLATE_SUCCESS(response))
  } catch (error) {
    yield put(FETCH_EMAIL_TEMPLATE_FAIL())
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchEmailTemplateSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_EMAIL_TEMPLATE, FetchEmailTemplateFlow)
}
